
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 5.5l.337.001C29.25 5.54 32.5 6.428 32.5 8l-.004-.073h.004v30.146a3.5 3.5 0 01-2.3 3.287c-2.383.87-3.727 1.14-6.2 1.14-2.473 0-3.817-.27-6.2-1.14a3.5 3.5 0 01-2.294-3.088l-.006-.2V7.928C15.603 6.366 18.977 5.5 24 5.5zm0 9l-.67-.005c-3.134-.05-5.555-.456-6.83-1.171v24.749a2.5 2.5 0 001.643 2.348c2.279.832 3.51 1.079 5.857 1.079 2.347 0 3.578-.247 5.857-1.079a2.5 2.5 0 001.636-2.164l.007-.184.002-24.75C30.138 14.089 27.46 14.5 24 14.5zm7.502-5.177c-1.275.716-3.697 1.122-6.832 1.172L24 10.5c-3.46 0-6.136-.41-7.5-1.176V12c0 .702 3.04 1.5 7.5 1.5l.642-.006c4.002-.07 6.716-.788 6.853-1.442L31.5 12zM24 6.5l-.324.001C19.394 6.54 16.5 7.315 16.5 8c0 .668 2.751 1.422 6.858 1.494L24 9.5c4.46 0 7.5-.798 7.5-1.5S28.46 6.5 24 6.5z","fill":"#979797","fill-rule":"nonzero"}})])
          )
        }
      }
    